import React from 'react';
import { Field } from 'formik';
import { createUseStyles } from 'react-jss';
import { string, arrayOf } from 'prop-types';
import { DisplayPieceWithSize } from './DisplayPieceWithSize';

const useStyles = createUseStyles({
  pieceSelector: {
    marginBottom: 24,
  },
  title: {
    fontSize: 16,
    letterSpacing: 0.47,
    marginBottom: 8,
  },
  grid: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  gridItem: {
    width: 270,
    margin: [2, 2],
  },
});

const PieceSelector = ({ templateName, pieces }) => {
  const classes = useStyles();
  return (
    <Field name={templateName}>
      {({ field, form }) => (
        <div className={classes.pieceSelector}>
          <div className={classes.title} />
          <div className={classes.grid}>
            {pieces.map(piece => (
              <div key={piece} className={classes.gridItem}>
                <DisplayPieceWithSize
                  checked={field.value.pieces.includes(piece)}
                  label={piece}
                  templateName={templateName}
                  piece={piece}
                  onChange={() => {
                    if (field.value.pieces.includes(piece)) {
                      form.setFieldValue(templateName, {
                        ...field.value,
                        pieces: field.value.pieces.filter(
                          value => value !== piece,
                        ),
                      });
                    } else {
                      form.setFieldValue(templateName, {
                        ...field.value,
                        pieces: field.value.pieces.concat(piece),
                      });
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </Field>
  );
};

PieceSelector.propTypes = {
  templateName: string.isRequired,
  pieces: arrayOf(String).isRequired,
};

export default PieceSelector;
